var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
var NotificationService = /** @class */ (function () {
    function NotificationService(snackBar, translate) {
        this.snackBar = snackBar;
        this.translate = translate;
    }
    NotificationService.prototype.open = function (message, messageValues, action) {
        var _this = this;
        if (messageValues === void 0) { messageValues = {}; }
        if (action === void 0) { action = null; }
        var modifiedNotificationAction = action && action.closable ? __assign({}, this.getDefaultCloseAction(), action) : action;
        this.translate.get(message, messageValues).subscribe(function (translatedMessage) {
            _this.snackBar.open(translatedMessage, modifiedNotificationAction ? modifiedNotificationAction.label : null, {
                duration: modifiedNotificationAction ? modifiedNotificationAction.duration : 3000,
                horizontalPosition: 'center'
            });
        });
    };
    NotificationService.prototype.dismiss = function () {
        this.snackBar.dismiss();
    };
    NotificationService.prototype.getDefaultCloseAction = function () {
        var _this = this;
        this.translate.get('CLOSE').subscribe(function (message) {
            _this.defaultCloseAction = {
                label: message,
                duration: 0
            };
        });
        return this.defaultCloseAction;
    };
    return NotificationService;
}());
export { NotificationService };
